'use client';
import React from 'react';
const S = {
solid:{bg:'var(--brand)',color:'var(--text-on-brand)',border:'1px solid transparent',hoverBg:'var(--brand-hover)'},
secondary:{bg:'var(--surface)',color:'var(--text-brand)',border:'1px solid var(--border-strong)',hoverBg:'var(--brand-tint)'},
ghost:{bg:'transparent',color:'var(--text-brand)',border:'1px solid transparent',hoverBg:'var(--brand-tint)'},
danger:{bg:'var(--danger)',color:'#fff',border:'1px solid transparent',hoverBg:'#992D24'},
};
const SIZES = {sm:{padding:'6px 12px',fontSize:'var(--text-sm)',height:32},md:{padding:'9px 16px',fontSize:'var(--text-sm)',height:38},lg:{padding:'12px 22px',fontSize:'var(--text-md)',height:46}};
export function Button({variant='solid', size='md', icon, disabled, children, style, ...rest}) {
  const v = S[variant] || S.solid, sz = SIZES[size] || SIZES.md;
  const [hover, setHover] = React.useState(false);
  return <button disabled={disabled} onMouseEnter={()=>setHover(true)} onMouseLeave={()=>setHover(false)}
    style={{display:'inline-flex',alignItems:'center',justifyContent:'center',gap:8,fontFamily:'var(--font-sans)',fontWeight:600,
      borderRadius:'var(--radius-md)',cursor:disabled?'not-allowed':'pointer',opacity:disabled?0.5:1,
      background:hover&&!disabled?v.hoverBg:v.bg,color:v.color,border:v.border,height:sz.height,padding:sz.padding,fontSize:sz.fontSize,
      transition:'background var(--dur-fast) var(--ease-out)',...style}} {...rest}>
    {icon}{children}
  </button>;
}
